const FinancialStatus = {
  type: 'FinancialPeriodStatus',
  dropdown: {
    valueKey: 'value',
    labelKey: 'label',
    isEnum: true,
  },
};

export default FinancialStatus;
